import * as React from 'react';

import classNames from 'classnames';

import AutoplayChangeSection from 'bundles/general-video-player/components/control-bar/settingsMenu/AutoplayChangeSection';
import PlaybackRateChangeSection from 'bundles/general-video-player/components/control-bar/settingsMenu/PlaybackRateChangeSection';
import ResolutionChangeSection from 'bundles/general-video-player/components/control-bar/settingsMenu/ResolutionChangeSection';
import type { ResolutionOption } from 'bundles/general-video-player/components/control-bar/settingsMenu/VideoSettingsMenu';

import 'css!./__styles__/SettingsMenuPopup';

export type Props = {
  // control visibility via prop to allow fade transitions
  visible: boolean;
  // resolution adjustment state
  currentResolution: ResolutionOption;
  supportedResolutions: ResolutionOption[];
  onIncreaseResolutionClick: (event: React.MouseEvent<HTMLElement>) => void;
  onDecreaseResolutionClick: (event: React.MouseEvent<HTMLElement>) => void;
  // playback rate state
  playbackRate: 0.75 | 1 | 1.25 | 1.5 | 1.75 | 2;
  onIncreasePlaybackRateClick: (event: React.MouseEvent<HTMLElement>) => void;
  onDecreasePlaybackRateClick: (event: React.MouseEvent<HTMLElement>) => void;
  // autoplay state
  hideAutoPlayToggle?: boolean;
  isAutoPlayEnabled: boolean;
  onAutoPlayChange?: (isAutoPlayEnabled: boolean) => void;
};

const SettingsMenuPopup = ({
  visible,
  currentResolution,
  supportedResolutions,
  onIncreaseResolutionClick,
  onDecreaseResolutionClick,
  playbackRate,
  onIncreasePlaybackRateClick,
  onDecreasePlaybackRateClick,
  isAutoPlayEnabled,
  onAutoPlayChange,
  hideAutoPlayToggle,
}: Props) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  <div
    className={classNames('rc-SettingsMenuPopup', { visible })}
    // We want to ensure that all clicks in this popup (and child components/elements) don't bubble up to the video player and end here
    onClick={(e) => {
      e.stopPropagation();
    }}
    onDoubleClick={(e) => {
      e.stopPropagation();
    }}
  >
    <ResolutionChangeSection
      currentResolution={currentResolution}
      supportedResolutions={supportedResolutions}
      onIncreaseResolutionClick={onIncreaseResolutionClick}
      onDecreaseResolutionClick={onDecreaseResolutionClick}
    />
    <PlaybackRateChangeSection
      playbackRate={playbackRate}
      onIncreasePlaybackRateClick={onIncreasePlaybackRateClick}
      onDecreasePlaybackRateClick={onDecreasePlaybackRateClick}
    />
    {!hideAutoPlayToggle && (
      <AutoplayChangeSection isAutoPlayEnabled={isAutoPlayEnabled} onAutoPlayChange={onAutoPlayChange} />
    )}
  </div>
);

export default SettingsMenuPopup;
